export enum VoteType {
  UP = 'UP',
  DOWN = 'DOWN',
}
